import {AnyAction} from 'redux';
import {ACTIVATE_MINI_GAME, SET_MINI_GAME_ID} from '../action';


/**
 * set the id of the mini-game we're about to play
 */
export function setMiniGameID(mini_game_id: string) : AnyAction
{
    return {type: SET_MINI_GAME_ID, payload: {mini_game_id}};
}


/**
 * activate the mini game when we're ready
 */
export function activateMiniGame() : AnyAction
{
    return {type: ACTIVATE_MINI_GAME, payload: {}};
}


/**
 * activate the mini game when we're ready
 */
export function clearMiniGameID() : AnyAction
{
    return {type: SET_MINI_GAME_ID, payload: { mini_game_id: null }};
}



// WEBPACK FOOTER //
// ./src/ts/store/actions/mini-game/miniGame.ts